module.exports = __webpack_public_path__ + "images/tvornice-radnicima2-f94ea1bd413c6ad8a7d02609bb5282d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/tvornice-radnicima2.jpg
// module id = 56
// module chunks = 0